;(function() {
  function swiperInit() {
    initMainSlider()
    initThumbsSlider()
    initPopupSlider()
  }

  // your main carousel (unchanged)
  function initMainSlider() {
    window.mainSlider = new Swiper('.js-media-list', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      // …any other options you already had
    })
  }

function initThumbsSlider() {
  if (window.thumbSlider) window.thumbSlider.destroy(true, true);

  window.thumbSlider = new Swiper('.js-media-sublist', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 12,
    slideToClickedSlide: true,

    // **NEW**: prevent Swiper stamping an explicit wrapper size
    setWrapperSize: false,

    // **NEW**: once all thumb‑images have loaded, recalc everything
    on: {
      imagesReady() {
        this.updateSize();
      }
    },

    breakpoints: {
      640:  { spaceBetween: 8 },
      1024: { spaceBetween: 12 }
    }
  });
}

  // your popup/lightbox slider (unchanged)
  function initPopupSlider() {
    if (window.popupSlider) window.popupSlider.destroy(true, true)
    window.popupSlider = new Swiper('.js-popup-slider', {
      direction: 'horizontal',
      slidesPerView: "auto",
      spaceBetween: 0,
      // …other options
    })
  }

  document.addEventListener('shopify:section:load', swiperInit)
  swiperInit()
})()